<template>
  <div class="skillResults">
    <div class="o-ndividualArea c-responsive-fixwidth skill-pad-adjust">
      <div class="o-ndividualTable">
        <div class="c-common-space o-individual-calls">
            <div class="col-md-12 o-no-padding">
                <!-- <form class="form-inline">
                    <div class="form-group">
                        <label for="exampleInputEmail3">Sort By</label>
                        <select class="form-control" v-model="sortSkill" @change="sortSkills()">
                            <option value="name">Sort Alphabetically</option>
                            <option value="priotiy">Sort by Order/Priority</option>
                        </select>
                    </div>
                </form> -->
            </div>
        </div>

        <div class="o-skills-listing" v-loading="loadingSkillList">
            <div class="row">
                <div class="ml-3 col col-sm-12 skill-listing-left" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
                    <!-- <div v-for="(skill,key) in skills" :key="key" :class="(selectedSkillId==skill.id)?'o-skill-box skill-box-mod c-common-gradient c-common-box-shadow skill-box-selected':'o-skill-box skill-box-mod c-common-gradient c-common-box-shadow'">
                      <div class="skill-box-left">
                        <div class="float-right">
                            <div class="input-group stylish-input-group">
                                <a href="javascript: void(0)" @click="updateSingleRateAmount(skill,key)" class="c-solid-btn btn-save-skill">Update</a>
                            </div>
                        </div>

                        <div class="skill-title">{{(skill.name)? skill.name : "NA"}}</div>
                        <div class="skill-details">
                          <div class="skill-details-box">
                              <p><span>Employees</span></p>
                              <p>{{(skill.employee_count) ? skill.employee_count:'0'}}</p>
                          </div>
                          <div class="skill-details-box">
                              <p><span>Priority</span></p>
                              <p>{{skill.priotiy}}</p>
                          </div>
                          <div class="skill-details-box">
                              <p class="text-center"><span>Rate Table</span></p>
                              <p class="w-50 text-center">
                                <input v-if="skill.skill_rates&&skill.skill_rates.length&&skill.skill_rates[rateIndex]" type="text" class="form-control" placeholder="$ Rate"  v-validate="{required: true}" name="rate" v-model="skill.skill_rates[rateIndex].amount" />
                                <label v-else>Please update the Base Rate</label>
                              </p>
                          </div>
                        </div>
                      </div>
                      
                    </div>                     -->
                
                    
                    <div v-loading="loading" class="individualCallSplit" id="individualCallSplit">
                        <table class="o-calls-table c-common-box-shadow c-radius3 c-margin-bottom-10 payroll-viewcall-table-align overflow-show">
                            <thead class="c-common-gradient">
                                <tr>
                                    <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Skill:</span></th>
                                    <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 text-center"><span class="o-no-margin-bottom">Employees:</span></th>
                                    <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 text-center"><span class="o-no-margin-bottom">Priority:</span></th>
                                    <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Rate</span></th>
                                    <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 text-center"><span class="o-no-margin-bottom">Action</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(skill,key) in skills" :key="key" class="c-common-gradient">
                                    <td :id="skill.id" align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                        <p>{{(skill.name)? skill.name : "NA"}}</p>
                                    </td>
                                    <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                        <p class="text-center">{{(skill.employee_count) ? skill.employee_count:'0'}}</p>
                                    </td>
                                    <td align="center" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                        <p class="text-center">{{skill.priotiy}}</p>
                                    </td>
                                    <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                        <input v-if="skill.skill_rates&&skill.skill_rates.length&&skill.skill_rates[rateIndex]" type="text" class="form-control" placeholder="$ Rate"  v-validate="{required: true}" name="rate" v-model="skill.skill_rates[rateIndex].amount" />
                                        <label v-else>Please update the Base Rate</label>
                                    </td>                      
                                    <td align="center" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 text-center">
                                        <div class="text-center">
                                            <a href="javascript: void(0)" @click="updateSingleRateAmount(skill,key)" class="c-solid-btn btn-save-skill" :class="{'greyBg': userRoleSlug=='auditor'}">Update</a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody> 
                        </table>                                 
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
 
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        VueEditor
    } from 'vue2-editor';
    import service from '../../services.js';
    import { bus } from '../../main';

    import dateTimeConvert from '../../timeConvert&Compare';
    export default {
        components: {
            VueEditor
        },
        props: ['myProp','rateId'],

        watch: {
            async myProp(newVal) {
                if (typeof newVal == "object") {
                    await this.getAllSkillS();
                } else {
                    if (newVal == "") {
                        await this.getAllSkillS();
                    } else {
                        if (newVal.length > 1) {
                            this.loadingSkillList=true;
                            this.skills = [];
                            this.storeMore = [];
                            this.next_page = "";
                            await service.get('skill/searchSkills', {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID,
                                    'skillSearch': newVal
                                })
                                .then((res) => {
                                    this.searchData = res.data.result;
                                    this.skills = [];
                                    this.employees = [];
                                    for (var i = 0; i < this.searchData.length; i++) {
                                        if (this.searchData[i].archived == 0) {
                                            this.skills.push(this.searchData[i]);
                                        }
                                    }
                                    this.loadingSkillList=false;
                                }).catch((err) => {
                                    console.log(err);
                                    this.loadingSkillList=false;
                                })
                        }
                    }
                }
            },
            async rateId(newVal) {
                this.rateIndex = parseInt(this.rateId)-1;
                await this.getAllSkillS();
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: "userClientID",
                getNotificationType: 'getNotificationType',
                userRoleSlug: 'userRoleSlug'
            }),
            filterEmployee() {
                if(!this.skillEmploySearch || this.skillEmploySearch == '')
                    return this.employees;

                return this.employees.filter((employee) => ((employee.employable&&employee.employable.first_name && employee.employable.first_name.toLowerCase().indexOf(this.skillEmploySearch.toLowerCase())!=-1) || (employee.employable&&employee.employable.last_name && employee.employable.last_name.toLowerCase().indexOf(this.skillEmploySearch.toLowerCase())!=-1)  ));
            }
        },

        data() {
            return {
                rate_amount: '',
                rateIndex: -1,
                employeeSkillDetailsTitle: '',
                clientData: null,
                emp_sort: '',
                tempSelectStatus: null,
                searchPattern: false,
                employeeList: [],
                employeeListLoad: false,
                global_skills_updated: [],
                skill_id_selected: '',
                skills: [],
                lockNotify: false,
                loadingSkillList:false,
                loadmoreloading:false,
                afterApi:false,
                total: 0,
                storeMore: [],
                page_no: 3,
                sortSkill: 'name',
                addSkill: {
                    'name': "",
                    'priotiy': "",
                    'description': "",
                    'client_id': '',
                    'rate_a': '',
                    'rate_b': '',
                    'rate_c': '',
                    'rate_d': '',
                    'rate_e': ''
                },
                next_page: "",
                search_query: "",
                validation_err: 0,
                status_message: "",
                skill_id: 0,
                skill_key: 0,
                lockEmployees: false,
                employeeStatus: [],
                selectStatus: null,
                selectedSkillId:'',
                selectedSkillName:'',
                // selectedEmployees: [],
                loading: false,
                selectSkillId: '',
                selectedFilter: null,
                selectedEmpId: [],
                skillEmploySearch:'',
                employees:[],
                skillEmployee:[],
                sms:'',
                notifyTab: 'email',
                notifySkillID: [],
                attachment : null,
                rate_table: ''
            }
        },

        async beforeMount() {},

        async mounted() {
            await this.getClient()
        },

        async created() {
            console.log(this.rateId);
            this.rateIndex = parseInt(this.rateId)-1;
            await this.getAllSkillS();
        },

        methods: {
            async getClient(){
                await service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                    this.clientData = res.data.result;
                    this.emp_sort = this.clientData.default_employee_sort                
                }).catch((err) => {
                    console.log(err);
                });        
            },

            checkDefaultSkillArchive(skill) {
                let name = skill.name.toLowerCase();
                // console.log(name);
                // console.log(skill.name.toLowerCase());
                if(name == 'steward' || name == 'dispatched by' || name == 'rss feed' || name == 'penalty rules')
                    return false;
                return true;
            },

            checkDefaultSkillEditName(skillName) {
                let name = skillName.toLowerCase();
                // console.log(skillName.toLowerCase());
                if(name == 'steward' || name == 'dispatched by' || name == 'rss feed' || name == 'penalty rules')
                    return true;
                return false;
            },

            openSkillEmployeeModal(id){
                this.skillEmployee = [];
                this.employeeSkillDetailsTitle = '';
                // console.log('openSkillEmployeeModal');
                // let payload = {
                //     'skill_id':this.selectedSkillId,
                //     'status_id':this.selectStatus,
                // }
                // if(this.emp_sort != '') {
                //     payload.sort = this.emp_sort;
                // }else {
                //     payload.sort = 'fname_asc';
                // }
               this.$modal.show('skill-employee-modal');
               let header = {
                   'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'clientId': this.userClientID,
                    'skillId': id
               }

               if(this.emp_sort != '') {
                    header.sort = this.emp_sort;
                }else {
                    header.sort = 'fname_asc';
                }

               service.get('employee/getEmployeeSkillDetails', header)
               .then((res) => {
                    this.skillEmployee=res.data.result;
                    this.employeeSkillDetailsTitle = res.data.result && res.data.result.length && res.data.result[0].skill_name ? res.data.result[0].skill_name:''
                    // console.log(res);
                }).catch(err =>{
                    console.log(err);
                });
            },

            closeSkillEmployee(){
                this.$modal.hide('skill-employee-modal');
            },

            exportData(){
                // this.copyToClipboard('skill-employee-details');
                let employee=[];
                this.skillEmployee.forEach(emp =>{
                    var temp={
                        'Employee ID': emp.id,
                        'Email': emp.email,
                        'Employee Name': emp.first_name+' '+emp.last_name,
                        'Employee Seniority': emp.employee_seniority?emp.employee_seniority:'',
                        'Skill Seniority': emp.skill_seniority?emp.skill_seniority:'',
                        'Employee Status': emp.name,
                        'Phone Number': emp.phone_number?emp.phone_number:''
                    }
                    employee.push(temp);
                });
                this.JSONToCSVConvertor(employee, this.employeeSkillDetailsTitle + " Skill Employees", true);
            },

            JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

                var CSV = '';
                //Set Report title in first row or line

                CSV += ReportTitle + '\r\n\n';

                //This condition will generate the Label/Header
                if (ShowLabel) {
                    var row = "";

                    //This loop will extract the label from 1st index of on array
                    for (var index in arrData[0]) {

                        //Now convert each value to string and comma-seprated
                        row += index + ',';
                    }

                    row = row.slice(0, -1);

                    //append Label row with line break
                    CSV += row + '\r\n';
                }

                //1st loop is to extract each row
                for (var i = 0; i < arrData.length; i++) {
                    var row = "";

                    //2nd loop will extract each column and convert it in string comma-seprated
                    for (var index in arrData[i]) {
                        row += '"' + arrData[i][index] + '",';
                    }

                    row.slice(0, row.length - 1);

                    //add a line break after each row
                    CSV += row + '\r\n';
                }

                if (CSV == '') {
                    alert("Invalid data");
                    return;
                }

                //Generate a file name
                var fileName = "Job_";
                //this will remove the blank-spaces from the title and replace it with an underscore
                fileName += ReportTitle.replace(/ /g, "_");

                //Initialize file format you want csv or xls
                var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

                // Now the little tricky part.
                // you can use either>> window.open(uri);
                // but this will not work in some browsers
                // or you will not get the correct file extension

                //this trick will generate a temp <a /> tag
                var link = document.createElement("a");
                link.href = uri;

                //set the visibility hidden so it will not effect on your web-layout
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";

                //this part will append the anchor tag and remove it after automatic click
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },            

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            sendNotify(){
              var formData;
              if(this.sms != ''){
                formData = {
                    message: this.sms,
                    //email: this.sms,
                    client_id: this.userClientID,
                    skill_id:this.notifySkillID[0],
                    user_id: this.userID
                };
                this.lockNotify=true;
                service.post('skill/notifyBySkill', formData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    //console.log(res);
                    this.lockNotify=false;
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Notify Successfully.',
                        type: 'success'
                    });
                    this.$modal.hide('batch-notify');
                }).catch((err) => {
                    console.log(err);
                    this.lockNotify=false;
                });
                // service.post('employee/notifyEmployeeBySkill', formData, {
                //     'Authorization': this.userToken,
                //     'cs3-context-role': this.userRole,
                //     'cs3-context-clientId': this.userClientID,
                // })
                // .then((res) => {
                //     //console.log(res);
                //     formData = {
                //         sms: this.sms,
                //         //email: this.sms,
                //         client_id: this.userClientID,
                //         skills: JSON.stringify(this.notifySkillID)
                //     };
                //     service.post('employee/notifyEmployeeBySkill', formData, {
                //         'Authorization': this.userToken,
                //         'cs3-context-role': this.userRole,
                //         'cs3-context-clientId': this.userClientID,
                //     })
                //     .then((res) => {
                //         //console.log(res);
                //         this.lockNotify=false;
                //         this.$notify({
                //             title: this.$t('success'),
                //             message: 'Notify Successfully.',
                //             type: 'success'
                //         });
                //         this.$modal.hide('batch-notify');
                //     }).catch((err) => {
                //         console.log(err);
                //         this.lockNotify=false;
                //     });
                //     //this.$modal.hide('batch-notify');
                // }).catch((err) => {
                //     console.log(err);
                //     this.lockNotify=false;
                // });
              }else{
                this.$notify.error({
                  title: this.$t('error'),
                  message: 'You cannot send a blank message.'
                });
              }
            },

            addBatchNotify(skillID) {
                //console.log("SKILL", skillID);
                this.notifySkillID = [];
                this.notifySkillID.push(skillID);
                this.sms="";
                // this.emailContent = "";
                // this.smsContent = "";
                this.$modal.show('batch-notify');
            },

            closeBatchNotify() {
                this.$modal.hide('batch-notify');
            },

            async getAllSkillS() {
                console.log("Check rateTable");
                this.$Progress.start();
                this.storeMore = [];
                this.next_page = "";
                this.loadingSkillList=true;
                this.afterApi=false;
                await service.get('skill', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then(async (res) => {
                    this.skills = res.data.result.data;
                    this.$forceUpdate();
                    // console.log(this.skills);
                    this.sortSkills();
                    this.selectStatus = this.skills[0];
                    this.employeeListLoad = true;
                    this.getEmployeeStatus();
                    this.loadingSkillList=false;
                    this.afterApi=true;
                    this.total = res.data.result.total;
                    this.$Progress.finish();
                    this.next_page = res.data.result.next_page_url;
                    if (this.next_page != null || this.next_page == "") {
                        this.loadmoreloading=true;
                        await service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        }).then((more) => {
                            this.storeMore = more.data.result.data;
                            this.next_page = more.data.result.next_page_url;
                            this.loadmoreloading=false;
                            this.$forceUpdate();
                            //console.log(more);
                        }).catch((err) => {
                            console.log(err);
                            this.loadmoreloading=false;
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loadingSkillList=false;
                    this.afterApi=true;
                });
                this.addSkill.client_id = this.userClientID;
            },

            loadMore() {
                var arr = this.skills;
                if (this.storeMore.length != 0) {
                    this.storeMore.forEach(function(entry) {
                        arr.push(entry);
                    })
                    // this.sortSkills();
                    this.storeMore = [];
                    // this.loadmoreloading=true;
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        }).then((res) => {
                            this.storeMore = res.data.result.data;
                            this.page_no += 1;
                            this.next_page = res.data.result.next_page_url;
                            // this.loadmoreloading=false;

                        }).catch((err) => {
                            console.log(err);
                            // this.loadmoreloading=false;
                        });
                    }
                } else
                    this.storeMore = [];
            },

            sortSkills() {
                if (this.sortSkill == "name") {
                    this.skills.sort(function(a, b) {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                    })
                } else {
                    this.skills.sort(function(a, b) {

                        if (a.priotiy < b.priotiy) return -1;
                        if (a.priotiy > b.priotiy) return 1;
                        return 0;
                    })
                }
                // this.selectedSkillId=this.skills[0].id;
            },

            async addNewSkill() {
                this.$validator.validateAll().then(async (result) => {
                    if (result) {
                        this.validation_err = 0;

                        await service.post('skill', this.addSkill, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                            })
                            .then(async(res) => {
                                this.status_message = res.data.status_message;
                                setTimeout(() => {
                                    this.$modal.hide('add-skill');
                                }, 500);
                                this.$notify({
                                    title: this.$t('success'),
                                    message: 'Skill Added Successfully.',
                                    type: 'success'
                                });
                                //this.skills=[];
                                await this.getAllSkillS();
                            }).catch((err) => {
                                console.log(err);
                            })

                    } else
                        this.validation_err = 1;

                });
            },

            addSkillModal() {
                this.addSkill['name'] = "";
                this.addSkill['description'] = "";
                this.addSkill['priotiy'] = "";
                this.status_message = "";
                this.addSkill.rate_a = '';
                this.addSkill.rate_b = '';
                this.addSkill.rate_c = '';
                this.addSkill.rate_d = '';
                this.addSkill.rate_e = '';
                this.$modal.show('add-skill');
            },

            closeAddSkill() {
                this.$modal.hide('add-skill');
            },

            openEditSkill(skill, key) {
                this.skill_key = key;
                this.status_message = "";
                this.addSkill.name = skill.name;
                this.addSkill.description = skill.description;
                this.addSkill.priotiy = skill.priotiy;
                // console.log(skill.skill_rates);
                let skill_rates = ['rate_a','rate_b','rate_c','rate_d','rate_e']
                for(let i=0;i<skill.skill_rates.length; i++) {
                    this.addSkill[skill_rates[i]]=skill.skill_rates[i].amount;
                    // this.addSkill.rate_a = skill.skill_rates[i].amount;
                    // this.addSkill.rate_b = skill.rate_b?skill.rate_b:'';
                    // this.addSkill.rate_c = skill.rate_c?skill.rate_c:'';
                    // this.addSkill.rate_d = skill.rate_d?skill.rate_d:'';
                    // this.addSkill.rate_e = skill.rate_e?skill.rate_e:'';
                }
                // console.log(this.addSkill);              
                this.skill_id = skill.id;
                this.$modal.show("edit-skill");
            },

            closeEditSkill() {
                this.$modal.hide('edit-skill');
            },
            
            editSkill() {
                if(this.userRoleSlug == 'auditor') {
                    return;
                }
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;
                        service.put('skill/' + this.skill_id, this.addSkill, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                            })
                            .then((res) => {
                                //console.log(res);
                                this.skills[this.skill_key].name = this.addSkill.name;
                                this.skills[this.skill_key].description = this.addSkill.description;
                                this.skills[this.skill_key].priotiy = this.addSkill.priotiy;
                                this.status_message = res.data.status_message;
                                this.getAllSkillS();
                                setTimeout(() => {
                                    this.$modal.hide('edit-skill');
                                }, 500);
                                this.$notify({
                                    title: this.$t('success'),
                                    message: 'Skill Updated Successfully.',
                                    type: 'success'
                                });
                            }).catch((err) => {
                                console.log(err);
                                this.$notify({
                                    title: this.$t('error'),
                                    message: 'Something went wrong!',
                                    type: 'error'
                                });
                            })


                    } else
                        this.validation_err = 1;

                });
            },

            archiveSkill(skillId) {
                this.$confirm('This will permanently archive the skill. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$Progress.start();
                    // console.log(skillId);
                    service.get('skill/' + skillId + '/archiveASkill', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: 'Archived Successfully.'
                        });
                        this.getAllSkillS();
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Archive canceled.'
                    });
                });
            },
            
            getEmployeeStatus(){
                // console.log("Get EmployeeStatus")
              service.get('employee/employee_status', {
                  'Authorization': this.userToken,
                  'cs3-context-role': this.userRole,
                  'cs3-context-clientId': this.userClientID,
              }).
              then((res) => {
                  this.employeeStatus = res.data.result;
                //   console.log(this.employeeStatus)
                  this.employeeStatus.sort(function(a, b) {

                      if (Number(a.priority) < Number(b.priority)) return -1;
                      if (Number(a.priority) > Number(b.priority)) return 1;
                      return 0;
                  });
                    this.selectStatus=this.employeeStatus[0].id;
                    this.getEmployeeWithStatusAndSkill();
                    // console.log("get Employee Status");
                  // this.$Progress.finish();
                  // this.loading = false;
              }).catch((err) => {
                  console.log(err);
                  // this.$Progress.finish();
                  // this.loading = false;
              });
            },

            selectAllEmployee() {
                this.global_skills_updated = [];
                this.selectedFilter = 'all';

                // this.selectedEmployees=this.employees;
                let self = this;
                
                this.filterEmployee.forEach(function(emp) {
                    emp.skill_id=self.selectedSkillId;
                    emp.skill_seniority = emp.employee_skills&&emp.employee_skills.length?emp.employee_skills[0].seniority:null;
                    self.global_skills_updated.push(emp);
                });
                this.employeeList = this.global_skills_updated;
            },

            selectNone() {
                this.global_skills_updated = [];
                this.selectedFilter = 'none';
                let self = this;
                this.filterEmployee.forEach(function(emp) {
                    // emp.skill_id=null;
                    emp.skill_id=null;
                    // this.global_skills_updated = [];
                    self.global_skills_updated.push(emp);
                });
                this.employeeList = this.global_skills_updated;
            },

            checkInput(index){
            //   console.log(index);
            //   console.log(typeof this.employees[index].skill_seniority);
            //   console.log(this.employees[index].skill_id);
              if(this.employees[index].skill_seniority==0){
                this.employees[index].skill_seniority=null;  
              }
            },

            changeEmployeeSkillArray(index,skillId,value) {
                let global_index = this.global_skills_updated.findIndex((element) => element.id == this.filterEmployee[index].id);
                if(this.global_skills_updated.length && global_index !== -1) {
                    this.global_skills_updated[global_index].id = this.filterEmployee[index].id;
                    this.global_skills_updated[global_index].name = this.filterEmployee[index].employable.first_name + ' ' + this.filterEmployee[index].employable.last_name;
                    this.global_skills_updated[global_index].skill_id = value;
                    this.global_skills_updated[global_index].skill_seniority = this.filterEmployee[index].skill_seniority;                
                }else {
                    let tempObj = {
                        id: this.filterEmployee[index].id,
                        skill_id: value,
                        name: this.filterEmployee[index].employable.first_name + ' ' + this.filterEmployee[index].employable.last_name,
                        skill_seniority: this.filterEmployee[index].skill_seniority,
                    };
                    this.global_skills_updated.push(tempObj);
                }
            },

            updateSkillEmployees(){
                // console.log(typeof this.global_skills_updated)
                // console.log(this.global_skills_updated)
              this.employeeListLoad = true;
              service.post('employee/updateEmployeeSkills',{
                'status_id':this.selectStatus,
                'skill_id':this.selectedSkillId,
                'skill_employee': this.global_skills_updated,

              }, {
                  'Authorization': this.userToken,
                  'cs3-context-role': this.userRole,
                  'cs3-context-clientId': this.userClientID,
              }).
              then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Skill Updated Successfully.',
                        type: 'success'
                    });
                    this.global_skills_updated = [];
                    this.getEmployeeWithStatusAndSkill();
              }).catch((err) => {
                  this.employeeListLoad = false;
                  console.log(err);
              });
            },

            async getEmployeeWithStatusAndSkill(){
                this.employeeListLoad = true;
                let header = {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }
                
                let payload = {
                    'skill_id':this.selectedSkillId,
                    'status_id':this.selectStatus,
                }
                if(this.emp_sort != '') {
                    payload.sort = this.emp_sort;
                }else {
                    payload.sort = 'fname_asc';
                }
                this.tempSelectStatus = this.selectStatus;
                if(this.skills!==[]&&this.selectStatus&&this.selectStatus!=""){
                    this.$Progress.start();
                    await service.post('employee/getEmployeeSkillSeniority', payload, header).then((res) => {
                        this.employees=res.data.result;
                        let self=this;
                        this.employees.forEach((emp) => {
                            emp.skill_id = emp.employee_skills && emp.employee_skills.length ? emp.employee_skills[0].skill_id : null;
                            emp.skill_seniority = emp.employee_skills && emp.employee_skills.length ? this.getRoundOffSkillSeniority(emp.employee_skills[0].seniority) : null
                        })
                    }).catch((err) => {
                        console.log(err);
                        this.employeeListLoad = false;
                    });  
                    this.employeeList = this.filterEmployee;
                }
                this.employeeListLoad = false;

            },

            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },

            async filterEmployeeList() {
                if(this.skillEmploySearch.length > 0) {
                    this.searchPattern = true;
                    if(this.selectStatus != 'all') {
                        let temp = this.selectStatus;
                        this.tempSelectStatus = temp;
                        this.selectStatus = "all"
                        if(this.skillEmploySearch.length == 1)
                            await this.getEmployeeWithStatusAndSkill();
                    } else {
                        this.searchPattern = true;
                        this.tempSelectStatus = 'all'
                    }                    
                } else {
                    this.searchPattern = false;
                    this.selectStatus = this.tempSelectStatus;
                    await this.getEmployeeWithStatusAndSkill();
                }               
                this.employeeList = this.filterEmployee;
            },
             
            async clearSkillEmploySearch() {
                this.skillEmploySearch = "";
                this.searchPattern = false;
                if(this.tempSelectStatus != null || this.tempSelectStatus != "")
                    this.selectStatus = this.tempSelectStatus;
                else this.selectStatus = 'all'
                await this.getEmployeeWithStatusAndSkill();
                this.employeeList = this.filterEmployee;
            },

            updateSingleRateAmount(skill,index) {
                if(this.userRoleSlug == 'auditor') {
                    return;
                }
                // console.log(index);
                let skillParams = {
                    'name': skill.name,
                    'priotiy': skill.priority,
                    'description': skill.description,
                    'client_id': skill.client_id,
                    'rate_a': skill.skill_rates&&skill.skill_rates.length&&skill.skill_rates[0]&&skill.skill_rates[0].amount!=''?Number(skill.skill_rates[0].amount):'',
                    'rate_b': skill.skill_rates&&skill.skill_rates.length&&skill.skill_rates[1]&&skill.skill_rates[1].amount!=''?Number(skill.skill_rates[1].amount):'',
                    'rate_c': skill.skill_rates&&skill.skill_rates.length&&skill.skill_rates[2]&&skill.skill_rates[2].amount!=''?Number(skill.skill_rates[2].amount):'',
                    'rate_d': skill.skill_rates&&skill.skill_rates.length&&skill.skill_rates[3]&&skill.skill_rates[3].amount!=''?Number(skill.skill_rates[3].amount):'',
                    'rate_e': skill.skill_rates&&skill.skill_rates.length&&skill.skill_rates[4]&&skill.skill_rates[4].amount!=''?Number(skill.skill_rates[4].amount):''
                }
                service.put('skill/' + skill.id, skillParams, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    this.getAllSkillS();
                    this.$notify({
                        title: this.$t('Success'),
                        message: 'Updated Successfully!',
                        type: 'success'
                    });
                    if(index == 0) {
                        bus.$emit('changeBaseRate', skill.skill_rates[this.rateIndex].amount);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.$notify({
                        title: this.$t('error'),
                        message: 'Something went wrong! Please check the number format once.',
                        type: 'error'
                    });
                })
            }
        }
    }

</script>
<style scoped>
    .greyBg {
        background-color: #c5c5c5!important;
        cursor: not-allowed;
        color: #e1e1e1;
    }    
    a:focus {
        color: #ffffff;
        background-color: #1AB677;
    }
    .float-right {
        float: right;
        margin-right: 10%;
    }
    .w-50 {
        margin-right: 25%;
        margin-left: 25%;
    }
    .w-75{
        width: 75%;
    }

    .instruction-text {
        color: #ff1010;
        font-size: 12px;
        font-weight: bold;
        padding-top: 10px;
    }
    .skill-seniority-input-span{
        display: inline-block;
        margin-left: 10px;
        width: 35%;
    }
    .remove-employee-skill-span{
        display: inline-block;
        /* float: right; */
        margin-top: 10px;
        width: 10%
    }
    .employee-skill-list-width{
        width: 50%;
        display: inline-block;
    }

    .form-control-1 {
        display: block;
        float: right;
        width: 25%;
        height: 34px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        -webkit-transition: border-color ease-in-out 0.15s,box-shadow ease-in-out 0.15s;
        -o-transition: border-color ease-in-out 0.15s,box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s,box-shadow ease-in-out 0.15s;
    }
    .assign-employee-list ul li {
        width: 100%;
        float: left;
        padding: 5px 10px;
    }
    .assign-employee-list ul {
        overflow-x: hidden;
        overflow-y: scroll;
        margin: 20px -10px 10px;
        background: #F4F7F8;
        max-height: 350px;
    }

    .o-custom-radio{
        display: inline-block;
        margin-top: 9px;
        margin-bottom: 5px;
        margin-right: 5px;
    }
    .c-selected-skill-header{
        font-size: 21px;
        font-weight: 600;
        text-align:center;
        margin-top: 6px;
    }
    .skill-select-mod{
        width:130px;
    }
    @media screen and (min-width:1366px){
        .skill-select-mod{
        width:120px;
        }
    }
    .skill-pad-adjust{
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/skills/rateTable.vue